import { Injectable } from '@angular/core'
declare global {
  interface Window {
    Razorpay: any
  }
}

@Injectable({
  providedIn: 'root'
})
export class RazorpayService {
  // Use a static promise to ensure the script is only loaded once per application lifecycle.
  private static loader: Promise<boolean> | null = null

  public load(): Promise<boolean> {
    if (RazorpayService.loader) {
      return RazorpayService.loader
    }

    RazorpayService.loader = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://checkout.razorpay.com/v1/checkout.js'
      script.async = true
      script.onload = () => {
        resolve(true)
      }
      script.onerror = () => {
        // Reset loader on error to allow retrying
        RazorpayService.loader = null
        reject(false)
      }
      document.body.appendChild(script)
    })

    return RazorpayService.loader
  }
}
